import $ from "jquery";

function getAjax(url, success, error) {
    $.ajax({
        url: global.mainDomainName + url,
        type: 'GET',
        crossDomain: true,
        // async: true,
        // data: 'twitterUsername=jquery4u',
        success: function (data) {
            success(data);
        },
        error: function (e) {
            console.log('error...');
            error(e);
        }
    });
}

function isJson(string) {
    // TODO
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;
}

function getGlobalDomainName() {
    return btoa(global.mainDomainName);
}

function decodeGlobalDomainName() {

}

export {getAjax, getGlobalDomainName, isJson}


// WEBPACK FOOTER //
// ./src/functions/functions.js